// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2Yqq_";
var _3 = "header-1EcaM";
var _4 = "airport-31vV8";
var _5 = "direction-1FcOE";
var _6 = "airport__iata-10kPT";
var _7 = "airport__name-N5PdI";
var _8 = "bottom-2hOX4";
var _9 = "when-2NGj8";
var _a = "date-2Fmt7";
var _b = "terminal-15j0A";
var _c = "terminal__code-3-DhW";
var _d = "footer-QSKtF";
var _e = "footer__direction-2xg3L";
var _f = "weather-3YsZB";
var _10 = "weather__value-2Xgli";
var _11 = "details-ClerB";
export { _1 as "__esModule", _2 as "wrapper", _3 as "header", _4 as "airport", _5 as "direction", _6 as "airport__iata", _7 as "airport__name", _8 as "bottom", _9 as "when", _a as "date", _b as "terminal", _c as "terminal__code", _d as "footer", _e as "footer__direction", _f as "weather", _10 as "weather__value", _11 as "details" }
export default { "__esModule": _1, "wrapper": _2, "header": _3, "airport": _4, "direction": _5, "airport__iata": _6, "airport__name": _7, "bottom": _8, "when": _9, "date": _a, "terminal": _b, "terminal__code": _c, "footer": _d, "footer__direction": _e, "weather": _f, "weather__value": _10, "details": _11 }
